import { GET_PRODUCT_ORDER, ADD_PRODUCT_ORDER, UPDATE_PRODUCT_ORDER,UPDATE_PRODUCT_ORDER_STATUS, DELETE_PRODUCT_ORDER } from "../types";
import {setAlert} from "./alert";
import axios from "../../axios";
import Swal from 'sweetalert2';
import { getErrorMessage } from "../../helpers/ErrorMessage";

export const getProductOrders = () => async (dispatch) => {
    try {
        const res = await axios.get("order/get");
        if (res.data.code === 1) {
            dispatch({type: GET_PRODUCT_ORDER, payload: res.data.data});
        }
    } catch (err) {
        console.log("Error fetching product orders:", err);
        const errorMessage = getErrorMessage(err.response?.data);
        Swal.fire({
            title: 'Error!',
            text: errorMessage,
            icon: 'error',
        });
    }
};


export const addProductOrder = (formData) => async (dispatch) => {
    try {
        const res = await axios.post("order/add", formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          });
        if (res.data.code === 1) {
            dispatch({type: ADD_PRODUCT_ORDER, payload: res.data.data});
            dispatch(setAlert(res.data.message, 'success'));
            Swal.fire({
              title: 'Success!',
              text: res.data.message,
              icon: 'success',
            });
        } else {
            dispatch(setAlert(res.data.message, "warning"));
        }
    } catch (err) {
        dispatch(setAlert(err.message, "danger"));
    }
};

export const updateProductOrder = (formData) => async (dispatch) => {
    try {
      const res = await axios.post("order/update", formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      
      if (res.data.code === 1) {
        dispatch({type: UPDATE_PRODUCT_ORDER, payload: res.data.data});
        Swal.fire({
          title: 'Success!',
          text: res.data.message,
          icon: 'success',
        });
        dispatch(setAlert(res.data.message, 'success'));
      } else {
        dispatch(setAlert(res.data.message, "warning"));
      }
    } catch (err) {
      dispatch(setAlert(err.message, 'danger'));
    }
  };

  // export const updateProductOrderStatus = (orderData) => async (dispatch) => {
  //   try {
  //     // Assuming `orderData` includes all necessary fields including orderStatus
  //     const formData = new FormData();
  //     if (orderData._id) {
  //       formData.append("id", orderData._id);
  //     }
  
  //     // Append other fields from orderData to formData, except for '_id'
  //     Object.keys(orderData).forEach(key => {
  //       if (orderData[key] !== undefined && orderData[key] !== null) {
  //         formData.append(key, orderData[key]);
  //       }
  //     });
  
  //     const res = await axios.post("order/update", orderData, {
  //       headers: {
  //         'Content-Type': 'multipart/form-data'
  //       }
  //     });
  
  //     if (res.data.code === 1) {
  //       dispatch({ type: UPDATE_PRODUCT_ORDER, payload: res.data.data });
  
  //       Swal.fire({
  //         title: 'Success!',
  //         text: res.data.message,
  //         icon: 'success',
  //       });
  
  //       dispatch(setAlert(res.data.message, 'success'));
  //     } else {
  //       dispatch(setAlert(res.data.message, 'warning'));
  //     }
  //   } catch (err) {
  //     console.error('Error updating product order:', err);
  //     dispatch(setAlert(err.message, 'danger'));
  //   }
  // };


  export const updateProductOrderStatus = (orderId, newStatus) => async (dispatch) => {
    try {
      const res = await axios.post("order/update", {
        id: orderId,
        orderStatus: newStatus
      });
  
      if (res.data.code === 1) {
        dispatch({ type: UPDATE_PRODUCT_ORDER_STATUS, payload: res.data.data });
  
        Swal.fire({
          title: 'Success!',
          text: res.data.message,
          icon: 'success',
        });
  
        dispatch(setAlert(res.data.message, 'success'));
      } else {
        dispatch(setAlert(res.data.message, 'warning'));
      }
    } catch (err) {
      console.error('Error updating product order status:', err);
      dispatch(setAlert(err.message, 'danger'));
    }
  };
export const deleteProductOrder = (_id) => async (dispatch) => {
    try {
        if (!_id) {
            dispatch(setAlert('Please select any record', 'warning'));
            return false;
        }
        const res = await axios.post(`order/delete/${_id}`);
        if (res.data.code === 1) {
            dispatch({type: DELETE_PRODUCT_ORDER, payload: {_id}});
            dispatch(setAlert(res.data.message, 'success'));
            Swal.fire({
                title: 'Success!',
                text: res.data.message,
                icon: 'success',
            });
        } else {
            dispatch(setAlert(res.data.message, "warning"));
        }
    } catch (err) {
        dispatch(setAlert(err.message, 'danger'));
    }
};





